import { environment } from '@environments/environment';
import { DomainConfig } from '@environments/model';

/**
 * Retrieves the domain configuration for the given hostname.
 *
 * This method normalizes the provided hostname to lowercase before performing
 * a lookup in the application's environment domain configuration object.
 *
 * @param {string} hostname - The hostname for which to retrieve the configuration.
 *                             Must be a non-empty string.
 * @returns {DomainConfig | undefined} The configuration object corresponding to the normalized hostname,
 *                                     or `undefined` if the hostname is empty or not found.
 * @example
 * // Usage example:
 * const domainConfig = getDomainConfig('example.com');
 * if (domainConfig) {
 *   console.log(`Domain found: ${domainConfig.name}`);
 * } else {
 *   console.log('Domain configuration not found.');
 * }
 */
export function getDomainConfig(hostname: string): DomainConfig | undefined {
  if (!hostname) {
    return undefined;
  }
  const normalizedHostname = hostname.toLowerCase();
  return environment.domains[normalizedHostname];
}
